<template>
    <edit-selection
        ref="input"
        v-model="inputValue"
        v-test-id
        :name="enumA11yKey"
        :outlined="outlined"
        :rules="validators"
        :label="label"
        :hint="hint"
        :description="description"
        :placeholder="hidePlaceholder ? null : placeholder"
        background-color="background"
        color="primaryText"
        item-color="primaryText"
        :form="form"
        :hide-details="hideDetails || !form"
        :disabled="disabled"
        :loading="loading"
        :readonly="readonly"
        :items="items"
        :required="required"
        :clearable="!required || clearable"
        :autocomplete="autocomplete"
        :error="error"
        :error-messages="errorMessages"
        :single-line="singleLine"
        :rounded="rounded"
        :multiple="multiple"
        @focus="$emit('focus', inputValue)"
        @blur="$emit('blur', inputValue)"
        @keyup="$emit('keyup', inputValue)"
        @keydown="$emit('keydown', inputValue)"
        @click="$emit('click', inputValue)"
        @change="$emit('change', inputValue)"
    >
        <template v-if="findSlot('item')" #item="attrs">
            <slot name="item" v-bind="attrs" />
        </template>
        <template #append>
            <slot name="append" />

            <app-tooltip v-if="info || findSlot('info')" :value="info" class="d-flex align-center">
                <v-icon dense small color="info" style="margin-bottom: 0.1rem">{{ getIcon('info', 'fad') }}</v-icon>
                <template v-if="findSlot('info')" #display>
                    <slot name="info" />
                </template>
            </app-tooltip>
        </template>
        <template #append-outer>
            <slot name="append-outer" />
        </template>
    </edit-selection>
</template>

<script>
import Edit from './Edit';

export default {
    name: 'EditEnum',
    extends: Edit,
    props: {
        enums: {
            type: [Object, Array],
            required: true
        },
        enumA11yKey: {
            type: String,
            default: null
        },
        multiple: {
            type: Boolean,
            default: false
        },
        autocomplete: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        items() {
            if (Array.isArray(this.enums)) {
                return this.enums.map(item => {
                    return {
                        text: this.enumA11yKey ? this.$t(`${this.enumA11yKey}.${item}`) : item,
                        value: item
                    };
                });
            }
            return Object.keys(this.enums).map(k => {
                return {
                    text: this.enumA11yKey ? this.$t(`${this.enumA11yKey}.${k}`) : this.enums[`${k}`],
                    value: k
                };
            });
        }
    }
};
</script>

<style lang="scss">
.edit__enum {
    min-width: 7rem;
}
</style>
